import { cn } from "../../utils/cn";

type SwitchProps = {
  checked: boolean;
  onChange: (next: boolean) => void;
  disabled?: boolean;
  className?: string;
  id?: string;
  "aria-label"?: string;
  /** Id(s) of element(s) that describe the toggle (e.g. its help text), so the
   *  description is programmatically associated for screen-reader users. */
  "aria-describedby"?: string;
};

export const Switch = ({
  checked,
  onChange,
  disabled,
  className,
  id,
  "aria-label": ariaLabel,
  "aria-describedby": ariaDescribedBy,
}: SwitchProps) => (
  <button
    type="button"
    role="switch"
    id={id}
    aria-checked={checked}
    aria-label={ariaLabel}
    aria-describedby={ariaDescribedBy}
    disabled={disabled}
    onClick={() => {
      if (!disabled) onChange(!checked);
    }}
    className={cn(
      "relative inline-flex h-5 w-9 shrink-0 items-center rounded-full transition-colors",
      "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/70",
      checked ? "bg-primary" : "bg-muted/40",
      disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer",
      className,
    )}
  >
    <span
      className={cn(
        "pointer-events-none inline-block h-4 w-4 rounded-full transition-transform",
        "bg-white/90 [.theme-smoked_&]:bg-foreground [.theme-spectre_&]:bg-foreground [.theme-reel_&]:bg-foreground",
        "shadow-[0_1px_1px_rgba(15,23,42,0.18)] dark:shadow-[0_1px_1px_rgba(0,0,0,0.45)]",
        checked ? "translate-x-[18px]" : "translate-x-0.5",
      )}
    />
  </button>
);
